export type FloorPriceChangesProps = {
    contracts?: { contract: string; tokens: string[] }[];
    slugs?: string[];
    date: Date;
};

interface FloorPriceChanges {
    currentPrice: string;
    slug: string;
    previousPrices: [{ date: string; price: string }];
    contractAddress?: string;
    tokenId?: string;
}

export type FloorPriceChangesResponse = FloorPriceChanges[];

export type CollectionOwnersResponse = { wallets: string[]; continuation?: string };
export type YacsTokensListProps = { tokens: { contract: string; token_ids: string[] }[] };

export const YACS_TOKENS_LIST_CACHE = 'yacs_tokens_list';
